import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import CustomerListPage from './pages/CustomerListPage';
import CreateCustomerPage from './pages/CreateCustomerPage';
import EditCustomerPage from './pages/EditCustomerPage';
import LoginPage from './pages/LoginPage';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    // This effect runs once when the app starts to check for a valid token
    useEffect(() => {
        const validateToken = async () => {
            const savedToken = localStorage.getItem('token');
            if (savedToken) {
                try {
                    // ✅ Updated to use the single, reliable auth_check.php endpoint
                    const response = await fetch('https://interactivebot.tgnsys.ir/api/auth_check.php', {
                        method: 'POST', // Using POST is fine, it only reads the header
                        headers: { 
                            'Authorization': `Bearer ${savedToken}`
                        },
                    });

                    // The 'ok' property checks for successful HTTP status codes (200-299)
                    if (response.ok) {
                        setIsAuthenticated(true);
                    } else {
                        // This will catch the 401 Unauthorized status from auth_check.php
                        localStorage.removeItem('token');
                        setIsAuthenticated(false);
                    }
                } catch (error) {
                    console.error('Token validation failed:', error);
                    localStorage.removeItem('token');
                    setIsAuthenticated(false);
                }
            }
            setIsLoading(false);
        };

        validateToken();
    }, []);

    // This function is passed to the LoginPage to update the app's state
    const handleLogin = (token) => {
        localStorage.setItem('token', token);
        setIsAuthenticated(true);
        navigate('/'); // Redirect to home page after login
    };

    // This function can be passed to protected pages to allow logging out
    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        navigate('/login'); // Redirect to login page after logout
    };

    // Show a loading screen until the initial token check is complete
    if (isLoading) {
        return <div style={{ textAlign: 'center', padding: '5rem', fontSize: '1.5rem' }}>Loading...</div>;
    }

    return (
        <Routes>
            <Route 
                path="/login"
                element={
                    !isAuthenticated ? (
                        <LoginPage onLogin={handleLogin} />
                    ) : (
                        <Navigate to="/" /> // If already logged in, redirect from /login to home
                    )
                }
            />
            <Route 
                path="/"
                element={
                    isAuthenticated ? (
                        <CustomerListPage onLogout={handleLogout} />
                    ) : (
                        <Navigate to="/login" /> // If not logged in, redirect to /login
                    )
                }
            />
            <Route 
                path="/create"
                element={
                    isAuthenticated ? (
                        <CreateCustomerPage onLogout={handleLogout} />
                    ) : (
                        <Navigate to="/login" />
                    )
                }
            />
            <Route 
                path="/edit/:customerId"
                element={
                    isAuthenticated ? (
                        <EditCustomerPage onLogout={handleLogout} />
                    ) : (
                        <Navigate to="/login" />
                    )
                }
            />
        </Routes>
    );
}

export default App;